export const environment = {
  production: false,
  APP_NAME: '{{ APP_NAME }}',
  API_URL: '{{ API_URL }}',
  COGNITO_USER_POOL_ID: '{{ COGNITO_USER_POOL_ID }}',
  COGNITO_USER_POOL_CLIENT_ID: '{{ COGNITO_USER_POOL_CLIENT_ID }}',
  STONLY_WID: '{{ STONLY_WID }}'
};
